export default __webpack_public_path__ + "static/media/extruder-down.51bd3b9e.svg";